import {
  COLOR_DANGER,
  COLOR_INFO,
  COLOR_MUTED,
  COLOR_PRIMARY,
  COLOR_SUCCESS,
  COLOR_WARNING,
  PLACEMENT_BOTTOM,
  PLACEMENT_LEFT,
  PLACEMENT_RIGHT,
  PLACEMENT_TOP,
} from '../../config/constants';

export const DROPDOWN_ITEM_COLORS = [
  COLOR_DANGER,
  COLOR_INFO,
  COLOR_MUTED,
  COLOR_PRIMARY,
  COLOR_SUCCESS,
  COLOR_WARNING,
];

export const DROPDOWN_CODE_DOWN = 40;
export const DROPDOWN_CODE_ESC = 27;
export const DROPDOWN_CODE_UP = 38;
export const DROPDOWN_CODE_SPACE = 32;
export const DROPDOWN_CODE_ENTER = 13;

export const DROPDOWN_MENU_POSITIONS = [
  PLACEMENT_TOP,
  PLACEMENT_BOTTOM,
];

export const DROPDOWN_MENU_ALIGNMENT = [
  PLACEMENT_LEFT,
  PLACEMENT_RIGHT,
];

export const DROPDOWN_ITEM_ICON_POSITIONS = [
  PLACEMENT_LEFT,
  PLACEMENT_RIGHT,
];

export const DROPDOWN_SELECTOR_FORM = '.dropdown form';
export const DROPDOWN_SELECTOR_ITEM = ['.dropdown-item'];
export const DROPDOWN_ACTIVE_ITEM_DATA_ATTRIBUTE = 'data-dropdown-item-active';
